"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6935],{

/***/ 25715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledInput = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input`
  display: block;
  width: 100%;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #e0e0e0;
  min-height: 16px;
  &:focus {
    outline: 0;
  }
  /* Chrome, Safari, Edge, Opera */
  &:-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
const Input = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({}, props));




/***/ }),

/***/ 12038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36885);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DropdownWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  width: 100%;
`;
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    isOpen,
    toggle,
    toggleType = "click",
    className,
    onHide
  } = _b, props = __objRest(_b, [
    "children",
    "isOpen",
    "toggle",
    "toggleType",
    "className",
    "onHide"
  ]);
  const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!isOpen) {
      return;
    }
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        toggle();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, isOpen]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DropdownProvider */ .K, {
    value: { isOpen, toggle, toggleType }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownWrapper, __spreadValues({
    onMouseEnter: toggleType === "hover" ? toggle : null,
    onMouseLeave: toggleType === "hover" ? onHide : null,
    className,
    ref: wrapperRef
  }, props), children));
};




/***/ }),

/***/ 36885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ DropdownContext; },
/* harmony export */   "K": function() { return /* binding */ DropdownProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const initialState = {
  referenceElement: null,
  toggle: () => {
  },
  isOpen: false,
  toggleType: ""
};
const DropdownContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({ state: initialState });
const DropdownProvider = ({ children, value }) => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((state2 = initialState, action) => {
    switch (action.type) {
      case "SET_REFERENCE":
        return __spreadProps(__spreadValues({}, state2), {
          referenceElement: action.payload
        });
      default:
        return state2;
    }
  }, initialState);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownContext.Provider, {
    value: { state: __spreadValues(__spreadValues({}, state), value), dispatch }
  }, children);
};




/***/ }),

/***/ 70705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36885);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _Popper_Popper_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16028);





const StyledDiv = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ show, origin }) => `
    background-color: transparent;
    // transition: transform 0.2s, opacity 0.2s;
    // transform: scale(${show ? 1 : 0});
    // transform-origin: ${origin};
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_Popper_Popper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Popper */ .r)(({ show }) => `
    visibility: ${show ? "visible" : "hidden"};
    z-index: 999;
  `);
const DropdownMenu = ({
  children,
  popperConfig,
  placement = "bottom-start",
  origin = "center top",
  className
}) => {
  const {
    state: { isOpen, referenceElement }
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .DropdownContext */ .D);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPopper, {
    className,
    referenceElement,
    popperConfig,
    placement,
    show: isOpen
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiv, {
    show: isOpen,
    origin
  }, children));
};




/***/ }),

/***/ 46207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownToggle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36885);




const StyledDiv = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const DropdownToggle = ({
  children,
  className
}) => {
  const [anchor, setAnchor] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const {
    state: { toggle, toggleType },
    dispatch
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DropdownContext */ .D);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    dispatch({ type: "SET_REFERENCE", payload: anchor });
  }, [anchor]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiv, {
    className,
    ref: setAnchor,
    onClick: toggleType === "click" ? toggle : null,
    onKeyUp: toggleType === "click" ? toggle : null,
    tabIndex: 0
  }, children);
};




/***/ }),

/***/ 78221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26759);
/* harmony import */ var _hooks_useEventCallback_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15271);




const Overlay = ({
  show,
  children,
  onEscPressed
}) => {
  const elmRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = "1070";
    elm.style.display = "flex";
    elm.style.justifyContent = "center";
    elm.style.alignItems = "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    document.body.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      document.body.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (0,_hooks_useEventCallback_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useEventCallback */ .$)((e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, elmRef.current);
};




/***/ }),

/***/ 16028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Popper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81668);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  [data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }
`;
const Popper = (_a) => {
  var {
    children,
    referenceElement,
    className,
    placement,
    popperConfig: _b = {}
  } = _a, _c = _b, { modifiers = [] } = _c, rest = __objRest(_c, ["modifiers"]);
  const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const { styles, attributes, update } = (0,react_popper__WEBPACK_IMPORTED_MODULE_2__/* .usePopper */ .D)(referenceElement, popperElement, __spreadValues({
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowElement }
      },
      {
        name: "flip",
        enabled: true
      },
      { name: "hide" },
      ...modifiers
    ]
  }, rest));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (update) {
      update();
    }
  }, [className]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadProps(__spreadValues({
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), {
    className
  }), children, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: setArrowElement,
    style: styles.arrow
  }));
};




/***/ }),

/***/ 61965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);
/* harmony import */ var _ButtonChevron_ButtonChevron_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78196);
/* harmony import */ var _Dropdown_Dropdown_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12038);
/* harmony import */ var _Dropdown_DropdownToggle_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46207);
/* harmony import */ var _Dropdown_DropdownMenu_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70705);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li */ .Z.li(({ selected, theme }) => `
    padding: 0.6rem 0.8rem;
    font-size: 14px;
    background-color: ${selected ? "#f7f7f7" : ""};
    color: ${selected ? theme.brand.primary : "inherit"};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background-color: #f7f7f7;
      color: ${theme.brand.primary};
      cursor: pointer;
    }
  `);
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span`
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 0.25rem;
  text-align: left;
`;
const Content = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul */ .Z.ul`
  border-radius: 0.25rem;
  border: 1px solid #e0e0e0;
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  box-shadow: 2px 2px 0.8rem 0 rgba(0, 0, 0, 0.08);
  overflow-y: auto;
`;
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, `
    width: 100%;
`);
const StyledButtonChevron = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ButtonChevron_ButtonChevron_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonChevron */ .y)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
  border-color: #e0e0e0;
`;
const StyledDropdown = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Dropdown_Dropdown_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Dropdown */ .L)`
  width: 100%;
  button {
    ${(p) => p.disabled ? `
      background-color: #f8f8fc;
      cursor: not-allowed;` : ""}
    > span:first-child {
      flex: 1;
      text-align: left;
    }
  }
`;
const sameWidthModifier = {
  name: "sameWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
  }
};
const dropdownConfigs = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 10]
      }
    }
  ]
};
const Select = (_a) => {
  var _b = _a, {
    title,
    onChange,
    items,
    selectedValue = null,
    variant,
    sameWidth = true,
    disabled = false
  } = _b, props = __objRest(_b, [
    "title",
    "onChange",
    "items",
    "selectedValue",
    "variant",
    "sameWidth",
    "disabled"
  ]);
  const [dropdownOpen, setDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const handleChange = ({ value }) => () => {
    setDropdownOpen(false);
    onChange(value);
  };
  const toggle = () => !disabled && setDropdownOpen((prevState) => !prevState);
  const currentTitle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (selectedValue === null) {
      return title;
    }
    const filteredItems = items.filter(({ value }) => value === selectedValue);
    return filteredItems.length > 0 ? filteredItems[0].content : title;
  }, [items, selectedValue, title]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDropdown, {
    isOpen: dropdownOpen,
    disabled,
    toggle
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Dropdown_DropdownToggle_es_js__WEBPACK_IMPORTED_MODULE_5__/* .DropdownToggle */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButtonChevron, {
    type: "button",
    direction: dropdownOpen ? "up" : "down",
    variant: variant === "invalid" ? "danger" : void 0,
    outline: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, currentTitle))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Dropdown_DropdownMenu_es_js__WEBPACK_IMPORTED_MODULE_6__/* .DropdownMenu */ .h, {
    popperConfig: __spreadProps(__spreadValues({}, dropdownConfigs), {
      modifiers: [
        ...dropdownConfigs.modifiers,
        sameWidth && sameWidthModifier
      ]
    })
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, items.map(({ content, value }, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListItem, {
    onClick: handleChange({ content, value }),
    selected: value === selectedValue,
    key: index
  }, content))))));
};




/***/ }),

/***/ 62411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51511);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _molecules_Overlay_Overlay_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78221);





const Backdrop = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  sm: "400px",
  md: "700px",
  lg: "960px"
};
const ModalContent = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme, size, maxHeight, borderRadius }) => `
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  width: ${sizeMaps[size]};
  border-radius: ${borderRadius ? borderRadius : theme.borderRadius};
  max-height: ${maxHeight ? maxHeight : `90%`};
  z-index: 1060;
  position: relative;
  overflow-y: auto;
`);
const Modal = ({
  show,
  onHide,
  children,
  className,
  size = "md",
  maxHeight,
  borderRadius
}) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof document !== "undefined") {
      if (show) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${(0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .getScrollbarWidth */ .np)()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_molecules_Overlay_Overlay_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .a, {
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Backdrop, {
    onClick: onHide
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalContent, {
    className,
    size,
    borderRadius,
    maxHeight
  }, children));
};




/***/ }),

/***/ 68752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`;




/***/ }),

/***/ 81250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  padding: 1rem;
  text-align: center;
  .title {
    margin-bottom: 0;
  }
`;
const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
  className
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h5", {
  className: "title"
}, children));




/***/ }),

/***/ 51511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nc": function() { return /* binding */ getImageUrlFromGoogleUserContent; },
/* harmony export */   "Nq": function() { return /* binding */ canUseDOM; },
/* harmony export */   "TH": function() { return /* binding */ getMoneyValueUnit; },
/* harmony export */   "np": function() { return /* binding */ getScrollbarWidth; }
/* harmony export */ });
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const getScrollbarWidth = () => {
  let width = 0;
  if (typeof window !== "undefined") {
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    window.scrollbarWidth = width;
  }
  return width;
};
const getMoneyValueUnit = (value) => {
  if (value < 1e6)
    return { value: Math.round(value / 1e3 * 1e3) / 1e3, unit: "K" };
  if (value > 1e9)
    return {
      value: Math.round(value / 1e9 * 1e3) / 1e3,
      unit: "t\u1EF7"
    };
  return { value: Math.round(value / 1e6 * 1e3) / 1e3, unit: "tr" };
};
const getImageUrlFromGoogleUserContent = (imageUrl, imageWidth) => {
  let result = imageUrl;
  if (imageUrl.includes("googleusercontent.com")) {
    if (imageWidth) {
      result = `${imageUrl}=w${imageWidth}`;
    }
  }
  return result;
};




/***/ }),

/***/ 15271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const useEventCallback = (fn, deps) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = fn;
  }, [fn, ...deps]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => {
    const callback = ref.current;
    callback(...args);
  }, [ref]);
};




/***/ })

}]);